module.exports = __webpack_public_path__ + "img/success_violet.e61bb32f.png";